import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Clock, ArrowRight, Truck } from 'lucide-react';
import { SHOP_URL } from '../mock';

const getCutoffState = () => {
  const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date());
  const hour = Number(parts.find((p) => p.type === 'hour').value) % 24;
  const minute = Number(parts.find((p) => p.type === 'minute').value);
  const minsLeft = 14 * 60 - (hour * 60 + minute);
  if (minsLeft > 0) {
    const h = Math.floor(minsLeft / 60);
    const m = minsLeft % 60;
    return { before: true, label: h > 0 ? `${h}h ${m}m` : `${m} min` };
  }
  return { before: false, label: null };
};

export const OrderTodayStrip = () => {
  const [state, setState] = useState(getCutoffState);
  useEffect(() => {
    const t = setInterval(() => setState(getCutoffState()), 60000);
    return () => clearInterval(t);
  }, []);
  const { before, label } = state;
  return (
    <section data-testid="order-today-strip" className="bg-[#C4715A]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-3.5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-center">
        <p className="text-[14px] sm:text-[15px] font-medium text-white leading-relaxed">
          {before ? <Clock className="w-4 h-4 inline-block align-[-2.5px] mr-1.5" /> : <Truck className="w-4 h-4 inline-block align-[-2.5px] mr-1.5" />}
          {before
            ? <>Need flowers today? Order within <span className="font-semibold whitespace-nowrap">{label}</span> for same-day delivery in Menlo Park, Atherton, Palo Alto &amp; Redwood City</>
            : <>Order now at menlofloristonline.com for first-route delivery tomorrow morning across Menlo Park &amp; the Peninsula</>}
        </p>
        <span className="flex items-center gap-3">
          <a href={SHOP_URL} data-testid="order-today-shop-link" className="inline-flex items-center gap-1.5 rounded-full bg-white text-[#C4715A] px-4 py-1.5 text-[13.5px] font-semibold hover:bg-[#F7E0D8] transition-colors">
            Order now <ArrowRight className="w-3.5 h-3.5" />
          </a>
          <Link to="/blog/same-day-flower-delivery-today-menlo-park" data-testid="order-today-guide-link" className="text-[13.5px] text-white/90 underline underline-offset-4 hover:text-white transition-colors">
            How same-day works
          </Link>
        </span>
      </div>
    </section>
  );
};

export default OrderTodayStrip;
